module.exports = __webpack_public_path__ + "static/media/ig.874c7a4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/MU/assets/ig.jpg
// module id = 190
// module chunks = 0